import BoxTitle from "@/routes/org/_components/box-title"
import HalfDoughnutChart from "@/routes/org/_components/half-doughnut/half-doughnut-chart"
import Flex from "@/components/flex"

const HalfDoughnutView = ({ title = "", chart }) => {
  return (
    <Flex className="flex-col justify-center items-center" gap={4}>
      <BoxTitle title={title} />
      <HalfDoughnutChart title={`${chart.pct ?? "-"}%`} data={chart.data} unit={chart.unit} />
    </Flex>
  )
}

export default HalfDoughnutView
